import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-655b645f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-cloud-container" }
const _hoisted_2 = {
  key: 0,
  class: "setting-cloud-container"
}
const _hoisted_3 = {
  key: 1,
  class: "setting-cloud-container"
}
const _hoisted_4 = {
  key: 2,
  class: "setting-cloud-container"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloudDisabled = _resolveComponent("CloudDisabled")!
  const _component_CloudEnabled = _resolveComponent("CloudEnabled")!
  const _component_CloudPending = _resolveComponent("CloudPending")!
  const _component_CloudError = _resolveComponent("CloudError")!
  const _component_ib_ok_cancel_dialog = _resolveComponent("ib-ok-cancel-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cloudStatus === _ctx.CLOUD_STATUS.Disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_CloudDisabled, {
            onScaleToCloud: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scaleToCloud())),
            onConnectWithSales: _cache[1] || (_cache[1] = ($event: any) => (_ctx.connectWithSales()))
          })
        ]))
      : ([_ctx.CLOUD_STATUS.Enabled, _ctx.CLOUD_STATUS.Paused, _ctx.CLOUD_STATUS.Expired].includes(_ctx.cloudStatus))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_CloudEnabled, {
              status: _ctx.cloudStatus,
              onCloudSettings: _ctx.scaleToCloud,
              onDeactivateCloud: _ctx.deactivateCloud,
              onPauseCloud: _ctx.pauseCloud,
              onResumeCloud: _ctx.resumeCloud,
              onConnectWithSales: _ctx.connectWithSales
            }, null, 8, ["status", "onCloudSettings", "onDeactivateCloud", "onPauseCloud", "onResumeCloud", "onConnectWithSales"])
          ]))
        : ([_ctx.CLOUD_STATUS.Creating, _ctx.CLOUD_STATUS.Deleting, _ctx.CLOUD_STATUS.Deactivating, _ctx.CLOUD_STATUS.InProcess].includes(_ctx.cloudStatus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_CloudPending, { "cloud-status": _ctx.cloudStatus }, null, 8, ["cloud-status"])
            ]))
          : (_ctx.cloudStatus === _ctx.CLOUD_STATUS.Error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CloudError)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_CloudPending, {
                  "cloud-status": _ctx.CLOUD_STATUS.Waiting
                }, null, 8, ["cloud-status"])
              ])),
    (_ctx.userRolePermissions.authorize?.value?.settings.enabled.cloud)
      ? (_openBlock(), _createBlock(_component_ib_ok_cancel_dialog, {
          key: 5,
          value: _ctx.isPauseCloudDialogOpen,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isPauseCloudDialogOpen) = $event)),
          class: "pause-cloud-dialog",
          "dialog-title": _ctx.$t('settings.cloud.dialogs.pause.title'),
          body: _ctx.$t('settings.cloud.dialogs.pause.title'),
          "checkbox-text": _ctx.$t('settings.cloud.dialogs.pause.checkboxText'),
          onOk: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pauseCloudConfirmed($event))),
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogCanceled())),
          onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogCanceled()))
        }, null, 8, ["value", "dialog-title", "body", "checkbox-text"]))
      : _createCommentVNode("", true),
    (_ctx.userRolePermissions.authorize?.value?.settings.enabled.cloud)
      ? (_openBlock(), _createBlock(_component_ib_ok_cancel_dialog, {
          key: 6,
          value: _ctx.isDeactivateCloudDialogOpen,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isDeactivateCloudDialogOpen) = $event)),
          class: "deactivate-cloud-dialog",
          "dialog-style": "warning",
          "dialog-title": _ctx.$t('settings.cloud.dialogs.deactivate.title'),
          body: _ctx.$t('settings.cloud.dialogs.deactivate.body'),
          "checkbox-verify-text": _ctx.$t('settings.cloud.dialogs.deactivate.checkboxVerifyText'),
          "body-icon": "warning",
          onOk: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deactivateCloudConfirmed())),
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogCanceled())),
          onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogCanceled()))
        }, null, 8, ["value", "dialog-title", "body", "checkbox-verify-text"]))
      : _createCommentVNode("", true)
  ]))
}